module.exports = __webpack_public_path__ + "img/lb_zww.f3c9f242.svg";